module.exports = __webpack_public_path__ + "static/media/asset_2.138fab3b.jpg";